const CAMPAIGN_URL = `${process.env.API_VPNONTRADER_HOST}/v1/subsidies/campaigns`;
const SUBSIDY_SCOPE = 'subsidy.*.*';

export default {
  getCampaign(id) {
    return this.get(`${CAMPAIGN_URL}/${id}?include_banner=true`, SUBSIDY_SCOPE, {
      responseErrorJson: true,
      enableAuthHeader: true,
    });
  },
};
